import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Materials from "./components/Materials";
import About from "./components/About";
import Reviews from "./components/Reviews";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import { LightboxProvider } from "./context/LightboxContext";
import Admin from "./pages/Admin";

const Home = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0b] text-[#f4efe6]">
      <Header />
      <main>
        <Hero />
        <Services />
        <Materials />
        <About />
        <Reviews />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <LightboxProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </LightboxProvider>
    </div>
  );
}

export default App;
